export default __webpack_public_path__ + "static/media/Byte_the_Code_logo.b03c0bb4.jpeg";